module.exports = __webpack_public_path__ + "static/media/produkcja.1298987b.svg";